/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, UsersAuthzResetUserPermissionsManagedPermissionsPathParams, UsersAuthzResetUserPermissionsManagedPermissions401, UsersAuthzResetUserPermissionsManagedPermissions403 } from "../models/UsersAuthzResetUserPermissionsManagedPermissions";

export function getUsersAuthzResetUserPermissionsManagedPermissionsUrl(userId: UsersAuthzResetUserPermissionsManagedPermissionsPathParams["userId"]) {
  const res = { method: 'POST', url: `/users-authz/v1/users/${userId}/permissions/reset` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Reset all permissions for a user
 * {@link /users-authz/v1/users/:userId/permissions/reset}
 */
export async function usersAuthzResetUserPermissionsManagedPermissions(userId: UsersAuthzResetUserPermissionsManagedPermissionsPathParams["userId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetUserPermissionsManagedPermissions401 | UsersAuthzResetUserPermissionsManagedPermissions403>, unknown>({ method : "POST", url : getUsersAuthzResetUserPermissionsManagedPermissionsUrl(userId).url.toString(), ... requestConfig })
  return res.data
}